import { Link } from "@tanstack/react-router";

import { docsSections } from "@/presentation/data/docs/docs-manifest";
import { cn } from "@monorepo-apps/ui/src/lib/utils";

interface DocsSidebarNavProps {
  activeSlug: string;
}

/** The left column: topic sections, each with its focused pages. */
export function DocsSidebarNav({ activeSlug }: DocsSidebarNavProps) {
  return (
    <nav className="flex flex-col gap-6" aria-label="Docs sections">
      {docsSections.map((section) => (
        <div key={section.label} className="flex flex-col gap-1">
          <p className="eyebrow mb-1 px-2">{section.label}</p>
          {section.pages.map((page) => (
            <Link
              key={page.slug}
              to="/docs"
              search={{ page: page.slug }}
              aria-current={page.slug === activeSlug ? "page" : undefined}
              className={cn(
                "rounded-md px-2 py-1 text-sm transition-colors",
                page.slug === activeSlug
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted/60"
              )}
            >
              {page.title}
            </Link>
          ))}
        </div>
      ))}
    </nav>
  );
}
